
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 28, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.45, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

export default function StrengthsSection() {
  const { t } = useTranslation();

  const strengths = [
    { icon: 'ri-cpu-line', title: t('strengths.tech.title'), desc: t('strengths.tech.desc') },
    { icon: 'ri-global-line', title: t('strengths.eu.title'), desc: t('strengths.eu.desc') },
    { icon: 'ri-shield-check-line', title: t('strengths.reliable.title'), desc: t('strengths.reliable.desc') },
    { icon: 'ri-message-3-line', title: t('strengths.fast.title'), desc: t('strengths.fast.desc') },
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#1a1d23]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {strengths.map((strength, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              whileHover={{ y: -6, transition: { duration: 0.18, ease: 'easeOut' } }}
              className="group p-10 rounded-2xl bg-[rgba(255,255,255,0.08)] backdrop-blur-xl border border-[rgba(255,255,255,0.12)] hover:border-[rgba(0,212,255,0.5)] hover:shadow-[0_8px_30px_rgba(0,212,255,0.2)] transition-colors duration-200 cursor-pointer"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 flex items-center justify-center mb-5">
                  <i className={`${strength.icon} text-[#00d4ff] text-4xl`}></i>
                </div>
                <h3 className="text-white text-xl font-semibold mb-3 whitespace-nowrap">
                  {strength.title}
                </h3>
                <p className="text-[rgba(255,255,255,0.6)] text-sm leading-relaxed">
                  {strength.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
